export default "__VITE_ASSET__13c42216__"